import type { TabsProps } from 'antd';
import { Tabs } from 'antd';
import { observer } from 'mobx-react';
import { Auth } from 'models';
import { MachineryFieldOperations } from 'modules/demo-mfe/components/MachineryFieldOperations';
import { PrescriptionExporter } from 'modules/demo-mfe/components/PrescriptionExporter';
import React from 'react';
import { MachineryUpload } from '../components/MachineryUpload';
import { ConnectFiles } from '../components/ConnectFiles';

const DemoMFEView = ({ viewModel }: { viewModel: Auth }) => {
  const items: TabsProps['items'] = [
    {
      key: 'machinery-field',
      label: 'Machinery Field Components',
      children: <MachineryFieldOperations orgId={viewModel.activeOrganization?.id || ''} />,
    },
    {
      key: 'prescription-exporter',
      label: 'Prescription Exporter',
      children: <PrescriptionExporter orgId={viewModel.activeOrganization?.id || ''} />,
    },
    {
      key: 'machinery-upload',
      label: 'Machinery Upload',
      children: (
        <MachineryUpload
          orgId={viewModel.activeOrganization?.id || ''}
          userId={viewModel.userId as string}
        />
      ),
    },
    {
      key: 'connect-files',
      label: 'Connect Files',
      children: <ConnectFiles orgId={viewModel.activeOrganization?.id || ''} />,
    },
  ];

  return (
    <div className="h-92vh pt-24 bg-white">
      <Tabs
        tabPosition="left"
        defaultActiveKey="machinery-field"
        items={items}
        className="h-100%"
      />
    </div>
  );
};

export default observer(DemoMFEView);
